<script>
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import IconX from "@js/components/Icons/IconX.vue";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import IconCart from "@js/components/Icons/IconCart.vue";
import {useCartStore} from "@js/store/CartStore.js";
import {Link} from "@inertiajs/vue3";
import IconShare from "@js/components/Icons/IconShare.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";

export default {
    name: "SpeedDial",
    components: {IconTelegram, IconWhatsApp, IconShare, IconCart, IconPhone, IconX, Link},
    methods: {
        share() {
            if (navigator.share) {
                navigator.share({
                    title: this.$page.props.title,
                    text: this.$page.props.description,
                    url: window.location.href
                })
            } else {
                this.copy()
            }
        },
    },
    setup() {
        const callbackStore = useCallbackFormsStore()
        const cartStore = useCartStore()

        return {callbackStore, cartStore}
    }
}
</script>

<template>
    <div data-dial-init class="fixed end-6 bottom-6 z-2">
        <div id="speed-dial-menu-default" class="flex flex-col items-center hidden mb-4 space-y-2">
            <!--Поделиться-->
            <button @click.prevent="share" aria-label="Поделиться"
                    type="button" data-tooltip-target="tooltip-share" data-tooltip-placement="left"
                    class="flex justify-center items-center w-[52px] h-[52px] text-gray-500 hover:text-gray-900 bg-white rounded-full border border-gray-200 hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 focus:outline-none">
                <IconShare class="w-5 h-5"/>
            </button>
            <div id="tooltip-share" role="tooltip"
                 class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
                Поделиться
                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            <!--Поделиться-->
            <!--WhatsApp-->
            <a href="https://api.whatsapp.com/send/?phone=79256649222&text&type=phone_number&app_absent=0"
               target="_blank" type="button" data-tooltip-target="tooltip-wa" data-tooltip-placement="left"
               class="flex justify-center items-center w-[52px] h-[52px] text-gray-500 hover:text-gray-900 bg-white rounded-full border border-gray-200 shadow-sm hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 focus:outline-none">
               <IconWhatsApp class="w-6 h-6 text-whatsapp"/>
            </a>
            <div id="tooltip-wa" role="tooltip"
                 class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
                WhatsApp
                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            <!--WhatsApp-->
            <!--Telegram-->
            <a href="https://t.me/Dorozhnyeplity"
               target="_blank" type="button" data-tooltip-target="tooltip-telegram" data-tooltip-placement="left"
               class="flex justify-center items-center w-[52px] h-[52px] text-gray-500 hover:text-gray-900 bg-white rounded-full border border-gray-200 shadow-sm hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 focus:outline-none">
                <IconTelegram class="w-5 h-5 -ms-0.5 text-telegram"/>
            </a>
            <div id="tooltip-telegram" role="tooltip"
                 class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
                Telegram
                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            <!--Telegram-->
            <!--Звонок-->
            <button @click.prevent="callbackStore.showCallbackPopup" aria-label="Звонок"
                    type="button" data-tooltip-target="tooltip-callback" data-tooltip-placement="left"
                    class="group flex justify-center items-center w-[52px] h-[52px] text-gray-500 hover:text-gray-900 bg-white rounded-full border border-gray-200 shadow-sm hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 focus:outline-none">
                <IconPhone class="w-7 h-7 text-indigo-600"/>
            </button>
            <div id="tooltip-callback" role="tooltip"
                 class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
                Обратный звонок
                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            <!--Звонок-->
        </div>
        <button type="button" data-dial-toggle="speed-dial-menu-default" aria-controls="speed-dial-menu-default"
                aria-expanded="false" aria-label="Быстрое меню"
                class="group flex items-center justify-center text-white bg-indigo-600 rounded-full w-14 h-14 hover:bg-indigo-800 focus:outline-none">
            <IconX class="w-6 h-6  stroke-white transition-transform rotate-45 group-hover:rotate-90"/>
        </button>
        <Link :href="route('cart')" v-if="cartStore.cart.length > 0"
              data-tooltip-target="tooltip-cart" data-tooltip-placement="left" aria-label="Перейти в корзину"
              class="group flex items-center justify-center text-white bg-indigo-600 rounded-full w-14 h-14 hover:bg-indigo-800 focus:outline-none mt-3">
            <IconCart class="w-7 h-7 stroke-white transition-transform"/>
        </Link>
        <div id="tooltip-cart" role="tooltip"
             class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
            Перейти в корзину
            <div class="tooltip-arrow" data-popper-arrow></div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.z-2 {
    z-index: 2;
}
</style>
